export const privacyDescList = [
  {
    privacy_key: 'UserInfo',
    privacyDesc: '用户信息（微信昵称、头像）',
    privacyType: 1,
    privacyType1: 2,
    privacyDesc1: '收集你的微信昵称、头像',
  },
  {
    privacy_key: 'Location',
    privacyDesc: '位置信息',
    privacyType: 1,
    privacyType1: 1,
    privacyDesc1: '收集你的位置信息',
  },
  {
    privacy_key: 'Address',
    privacyDesc: '地址',
    privacyType: 2,
    privacyType1: 2,
    privacyDesc1: '收集你的地址',
  },
  {
    privacy_key: 'Invoice',
    privacyDesc: '发票信息',
    privacyType: 2,
    privacyType1: 2,
    privacyDesc1: '收集你的发票信息',
  },
  {
    privacy_key: 'RunData',
    privacyDesc: '微信运动数据',
    privacyType: 1,
    privacyType1: 1,
    privacyDesc1: '收集你的微信运动步数',
  },
  {
    privacy_key: 'Record',
    privacyDesc: '麦克风',
    privacyType: 1,
    privacyType1: 1,
    privacyDesc1: '访问你的麦克风',
  },
  {
    privacy_key: 'Album',
    privacyDesc: '选中的照片或视频信息',
    privacyType: 2,
    privacyType1: 2,
    privacyDesc1: '收集你选中的照片或视频信息',
  },
  {
    privacy_key: 'Camera',
    privacyDesc: '摄像头',
    privacyType: 1,
    privacyType1: 1,
    privacyDesc1: '访问你的摄像头',
  },
  {
    privacy_key: 'PhoneNumber',
    privacyDesc: '手机号',
    privacyType: 1,
    privacyType1: 2,
    privacyDesc1: '收集你的手机号',
  },
  {
    privacy_key: 'Contact',
    privacyDesc: '通讯录（仅写入）权限',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '使用你的通讯录（仅写入）权限',
  },
  {
    privacy_key: 'DeviceInfo',
    privacyDesc: '设备信息',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '',
  },
  {
    privacy_key: 'EXIDNumber',
    privacyDesc: '身份证号码',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '',
  },
  {
    privacy_key: 'EXOrderInfo',
    privacyDesc: '订单信息',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '',
  },
  {
    privacy_key: 'EXUserPublishContent',
    privacyDesc: '发布内容',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '',
  },
  {
    privacy_key: 'EXUserFollowAcct',
    privacyDesc: '所关注账号',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '',
  },
  {
    privacy_key: 'EXUserOpLog',
    privacyDesc: '操作日志',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '',
  },
  {
    privacy_key: 'AlbumWriteOnly',
    privacyDesc: '相册（仅写入）权限',
    privacyType: 1,
    privacyType1: 1,
    privacyDesc1: '使用你的相册（仅写入）权限',
  },
  {
    privacy_key: 'LicensePlate',
    privacyDesc: '车牌号',
    privacyType: 1,
    privacyType1: 2,
    privacyDesc1: '收集你的车牌号',
  },
  {
    privacy_key: 'BlueTooth',
    privacyDesc: '蓝牙',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '访问你的蓝牙',
  },
  {
    privacy_key: 'CalendarWriteOnly',
    privacyDesc: '日历（仅写入）权限',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '使用你的日历（仅写入）权限',
  },
  {
    privacy_key: 'Email',
    privacyDesc: '邮箱',
    privacyType: 2,
    privacyType1: 0,
    privacyDesc1: '',
  },
  {
    privacy_key: 'MessageFile',
    privacyDesc: '选中的文件',
    privacyType: 2,
    privacyType1: 2,
    privacyDesc1: '收集你选中的文件',
  },
  {
    privacy_key: 'ChooseLocation',
    privacyDesc: '选择的位置信息',
    privacyType: 1,
    privacyType1: 1,
    privacyDesc1: '获取你的位置信息',
  },
  {
    privacy_key: 'Clipboard',
    privacyDesc: '剪切板',
    privacyType: 1,
    privacyType1: 1,
    privacyDesc1: '获取你的剪切板内容',
  },
];
